import * as api from '../apis/users';
import { apiCall } from '~/lib/redux/api';
import { EntityActions, UsersActions } from './consts';
import { UserNormalizer } from './normalize';
import { defaultTablePageSize } from '~/common/components/consts';


/********************************************
 *************  V2 version  *****************
 ********************************************/

export function getUserById(userId) {
  return apiCall({
    actions: [
      UsersActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, UsersActions.LOAD_SUCCESS],
      UsersActions.LOAD_ERROR,
    ],
    normalizer: UserNormalizer,
    fn: () => api.getUserById(userId),
  });
}

// TODO: Use constants
export function getOrgUsers(q: string = null, offset=0, limit=defaultTablePageSize) {
  return apiCall({
    actions: [
      UsersActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, UsersActions.LOAD_LIST_SUCCESS],
      UsersActions.LOAD_ERROR,
    ],
    normalizer: [UserNormalizer],
    fn: () => api.getOrgUsers(q, offset, limit),
  })
}

export function resetSuccessMessage() {
  return {
    type: UsersActions.RESET_SUCCESS_MESSAGE,
  }
}

export function createUser(req) {
  return apiCall({
    actions: [
      UsersActions.SAVE_REQUEST,
      [EntityActions.ADD_ENTITIES, UsersActions.LOAD_SUCCESS, UsersActions.CREATE_SUCCESS],
      UsersActions.SAVE_ERROR,
    ],
    normalizer: UserNormalizer,
    fn: () => api.createUser(req),
  });
}

export function updateUser(userId, req) {
  return apiCall({
    actions: [
      UsersActions.SAVE_REQUEST,
      [EntityActions.ADD_ENTITIES, UsersActions.LOAD_SUCCESS, UsersActions.SAVE_SUCCESS],
      UsersActions.SAVE_ERROR,
    ],
    normalizer: UserNormalizer,
    fn: () => api.updateUser(userId, req),
  });
}

export function setUserCurrentPage(page) {
  return {
    type: UsersActions.SET_CURRENT_PAGE,
    currentPage: page,
  }
}

export function deleteUser(userId: number) {
  return apiCall({
    actions: [
      UsersActions.LOAD_REQUEST,
      UsersActions.LOAD_SUCCESS,
      UsersActions.LOAD_ERROR,
    ],
    normalizer: UserNormalizer,
    fn: () => api.deleteUser(userId),
  })
}
